export default "__VITE_ASSET__4LT7IRp6__"